import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { adminGet, adminDel } from "@/lib/adminApi";
import { Avatar } from "@/components/admin/ClientFiche";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const load = () => adminGet("/users").then((d) => setUsers(d.users)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  // La fiche s'ouvre dans sa propre page
  const open = (u) => navigate(`/admin/patientele/${u.id}`);

  const remove = async (e, u) => {
    e.stopPropagation();
    if (!window.confirm(`Supprimer le compte de ${u.name || u.email} ? Cette action est définitive.`)) return;
    try {
      await adminDel(`/users/${u.id}`);
      toast("Compte supprimé.");
      load();
    } catch (err) {
      toast(err.response?.data?.detail || "Suppression impossible.");
    }
  };

  const filtered = users.filter(
    (u) =>
      u.email.toLowerCase().includes(search.toLowerCase()) ||
      (u.name || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.last_name || "").toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div data-testid="admin-users-module">
      <h2 className="rav-admin-h2">Patientèle</h2>
      <input
        className="rav-input rav-admin-search"
        data-testid="admin-users-search"
        placeholder="Rechercher un compte…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <div className="rav-admin-list">
        {filtered.map((u, i) => (
          <button key={u.id} type="button" className="rav-admin-row rav-admin-row-btn rav-admin-user-row" data-testid={`user-row-${i}`} onClick={() => open(u)}>
            <Avatar user={u} />
            <span className="rav-admin-user-texts">
              <span className="rav-admin-row-label">
                {[u.name, u.last_name].filter(Boolean).join(" ") || "—"}
                {u.role === "superadmin" ? " · super admin" : ""}
              </span>
              <span className="rav-admin-row-sub">
                {u.email} · inscrite le {String(u.created_at).slice(0, 10)}
              </span>
            </span>
            {u.role !== "superadmin" && (
              <span
                role="button"
                tabIndex={0}
                className="rav-admin-trash"
                data-testid={`user-delete-${i}`}
                aria-label={`Supprimer ${u.name || u.email}`}
                onClick={(e) => remove(e, u)}
                onKeyDown={(e) => e.key === "Enter" && remove(e, u)}
              >
                <Trash2 size={17} strokeWidth={1.6} />
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
